import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => {
    return createStyles({
        sliderMark: {
            width: '12px',
            height: '12px',
            backgroundColor: '#8c8c8c',
            borderRadius: '50%',
            margin: '-5px',
            opacity: 1,
        },

        sliderMarkLabel: {
            color: '#fff',
            whiteSpace: 'normal',
            textAlign: 'center',
        },

        sliderRail: {
            backgroundColor: 'rgba(255, 255, 255, .2)',
        },

        sliderTrack: {
            backgroundColor: 'rgb(255, 255, 255)',
        },

        sliderThumb: {
            backgroundColor: 'rgb(255, 255, 255)',
            '&:hover': {
                boxShadow: '0 0 0 8px rgba(255, 255, 255, 0.16)',
            },
        },

        sliderValueLabel: {
            color: 'rgba(0, 0, 0, 0)',
            top: '-25px',
        },
    });
});
